import { useMemo } from "react";

/**
 * Hook to detect if the app is running in an iFrame.
 *
 * @returns true if running in an iFrame, false otherwise
 */
export function useIsInIframe(): boolean {
  return useMemo(() => {
    if (typeof window === "undefined") return false;

    try {
      return window.parent !== window;
    } catch (error) {
      return true;
    }
  }, []);
}

/**
 * Hook to get custom styling for Dialog components when in an iFrame.
 * Positions the modal near the top of the viewport instead of centering it.
 *
 * @returns An object with sx styles to apply to Dialog's slotProps.paper
 */
export function useDialogIframeStyles() {
  const isInIframe = useIsInIframe();

  return useMemo(() => {
    if (!isInIframe) return {};

    return {
      marginTop: "15vh",
      marginBottom: "auto",
      maxHeight: "90vh",
      overflow: "auto",
    };
  }, [isInIframe]);
}
